var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"default-active":_vm.defaultActive,"unique-opened":"","router":""}},_vm._l((_vm.treeData),function(item){return _c('menu-tree-item',{key:((item.type || 'leaf') + "-" + (item.id)),attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }